export interface SubtractionKeepAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly kind: 'image';
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/number-kingdom/subtraction-keep';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): SubtractionKeepAsset => ({ key, path: `${ROOT}/${path}`, width, height, kind: 'image', alpha, required: true });

export const SUBTRACTION_KEEP_ASSETS = {
  dormant: image('subtraction-keep-dormant', 'backgrounds/subtraction-keep-dormant.png', 1280, 720, false),
  restored: image('subtraction-keep-restored', 'backgrounds/subtraction-keep-restored.png', 1280, 720, false),
  exchangeVault: image('subtraction-keep-exchange-vault', 'interactives/exchange-vault.png', 512, 512, true),
  missionPanel: image('subtraction-keep-mission-panel', 'ui/mission-panel.png', 900, 360, true),
  actionButton: image('subtraction-keep-action-button', 'ui/action-button.png', 384, 192, true),
  magicBurst: image('subtraction-keep-magic-burst', 'vfx/decomposition-restoration-burst.png', 768, 768, true),
} as const;

export const SUBTRACTION_KEEP_ASSET_LIST = Object.values(SUBTRACTION_KEEP_ASSETS);
export const SUBTRACTION_KEEP_PRODUCTION_READY = true;

export function preloadSubtractionKeepAssets(scene: Phaser.Scene) {
  SUBTRACTION_KEEP_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingSubtractionKeepAssets(textures: Phaser.Textures.TextureManager) {
  return SUBTRACTION_KEEP_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterSubtractionKeep(textures: Phaser.Textures.TextureManager) {
  return SUBTRACTION_KEEP_PRODUCTION_READY
    && getMissingSubtractionKeepAssets(textures).length === 0;
}
